export enum Locales {
  EN = 'en-US',
  UA = 'uk-UA'
}